import * as React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { completeDealCredixCheckAPI } from 'api/completeDeal'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'
import { getPositionLabel } from 'utilities/resources/options'
import { numberFormat } from 'utilities/typeUtility'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [isSpinningSubmit, setIsSpinningSubmit] = React.useState(false)
  const purchasePositionData = loginData.getPurchasePositionData()
  const positionNumbers = purchasePositionData?.positionNumbers ?? []

  /**
   * 「更新する」ボタン
   */
  const handlePaymentCheckButton = async () => {
    setIsSpinningSubmit(true)
    await completeDealCredixCheckAPI({ positionNumbers }, (isPayed) => {
      if (isPayed) {
        navigate('/aubeQuestDealPurchaseComplete')
      }
    })
    setIsSpinningSubmit(false)
  }

  React.useEffect(() => {
    if (!loginData.isLoggedIn() || !purchasePositionData) {
      navigate('/')
    }
  }, [navigate, purchasePositionData])
  return (
    <>
      <Header title="クレジットカード入金確認中" />
      <main>
        <section className="mx-4 my-5">
          <div>
            クレジットカード入金処理中です。
            <br />
            しばらく経ってからログインするか、以下の更新ボタンをクリックしてください。
          </div>
          <div className="mt-5">
            <h3 className="fw-bold">決済ポジション</h3>
            {positionNumbers.map((name, index) => (
              <div className="fw-bold mt-1" key={index}>
                {getPositionLabel(name)}
              </div>
            ))}
          </div>
          <div className="mt-5">
            <div>AUBEクエストディール</div>
            <div className="fw-bold mt-1">価格&nbsp;&nbsp;&nbsp;¥{numberFormat(purchasePositionData?.amount)}（税込）</div>
          </div>
          <div className="mt-5">
            <Button variant="primary" className="w-100 py-4" disabled={isSpinningSubmit} onClick={handlePaymentCheckButton}>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isSpinningSubmit} />
              更新する
            </Button>
          </div>
          {loginData.canUseNavMenu() && (
            <div className="mt-5 text-center">
              <Button variant="link" onClick={() => navigate('/myPage')}>
                マイページに戻る
              </Button>
            </div>
          )}
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
